import React, { useState } from 'react';

interface ProductImageProps {
  src?: string | null;
  alt: string;
  height?: number | string;
  width?: number | string;
  className?: string;
  wrapperClassName?: string;
  style?: React.CSSProperties;
  onError?: () => void;
}

const ProductImage: React.FC<ProductImageProps> = ({
  src,
  alt,
  height = 250,
  width = '100%',
  className = '',
  wrapperClassName = '',
  style,
  onError,
}) => {
  const [hasError, setHasError] = useState(false);

  const containerHeight = typeof height === 'number' ? `${height}px` : height;
  const containerWidth = typeof width === 'number' ? `${width}px` : width;

  const handleImageError = () => {
    setHasError(true);
    if (onError) {
      onError();
    }
  };

  const showFallback = !src || hasError;

  if (showFallback) {
    return (
      <div
        className={`product-card-image-wrapper bg-dark d-flex align-items-center justify-content-center text-white ${wrapperClassName}`}
        style={{
          height: containerHeight,
          width: containerWidth,
          backgroundColor: '#0d1117',
          ...style,
        }}
      >
        <div className="text-center">
          <i className="bi bi-image" style={{ fontSize: typeof height === 'number' && height < 100 ? '1.5rem' : '3rem', opacity: 0.3 }}></i>
          {typeof height === 'number' && height >= 150 && (
            <p className="small mt-2 mb-0 text-muted-soft" style={{ opacity: 0.5 }}>
              No Image
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      className={`product-card-image-wrapper ${wrapperClassName}`}
      style={{
        height: containerHeight,
        width: containerWidth,
        ...style,
      }}
    >
      <img
        src={src}
        alt={alt}
        className={`product-card-img ${className}`}
        loading="lazy"
        onError={handleImageError}
      />
    </div>
  );
};

export default ProductImage;
